module.exports = __webpack_public_path__ + "static/media/space_icon_active.5803fd92.svg";